import usePortal from 'react-useportal';

function Overlay() {
    var { openPortal, closePortal, isOpen, Portal } = usePortal();

    return (
        <Portal>
            <div className="AROverlay"></div>
        </Portal>
    );
}

export default Overlay;
